import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"padding":"30px 20px","width":"90vw","min-height":"70vh","position":"relative"} }
const _hoisted_2 = { class: "center-wrapper" }
const _hoisted_3 = { class: "input-inline" }
const _hoisted_4 = { class: "input-inline" }
const _hoisted_5 = { class: "input-inline" }
const _hoisted_6 = { class: "input-inline" }
const _hoisted_7 = { class: "input-inline inline-or-block" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JapaneseInput = _resolveComponent("JapaneseInput")!
  const _component_select_prefecture = _resolveComponent("select-prefecture")!
  const _component_pager = _resolveComponent("pager")!
  const _component_dialog_frame = _resolveComponent("dialog-frame")!

  return (_ctx.isDisplay)
    ? (_openBlock(), _createBlock(_component_dialog_frame, {
        key: 0,
        onClickBackground: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "close-button-position-absolute",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
            }, "x"),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "inline-label" }, "顧客コード", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control search-customer-code no-ime",
                  type: "tel",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchReq.id) = $event)),
                  onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toHankakuCode && _ctx.toHankakuCode(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.searchReq.id]
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "inline-label" }, "顧客名", -1)),
                _createVNode(_component_JapaneseInput, {
                  class: "search-customer-name",
                  modelValue: _ctx.searchReq.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchReq.name) = $event)),
                  onKeydown: _withKeys(_ctx.search, ["enter"]),
                  onChange: _ctx.toHankanaWhole
                }, null, 8, ["modelValue", "onKeydown", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "inline-label" }, "電話番号", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control search-customer-phoneNo no-ime",
                  type: "tel",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchReq.phoneNo) = $event)),
                  onKeydown: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"])),
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toHankakuPhone && _ctx.toHankakuPhone(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.searchReq.phoneNo]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "inline-label" }, "都道府県", -1)),
                _createVNode(_component_select_prefecture, {
                  prefecture: _ctx.searchReq.prefecture,
                  "onUpdate:prefecture": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchReq.prefecture) = $event)),
                  onKeydown: _withKeys(_ctx.search, ["enter"])
                }, null, 8, ["prefecture", "onKeydown"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "btn-primary",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
                }, "検索")
              ])
            ]),
            _createElementVNode("table", null, [
              _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                _createElementVNode("tr", { class: "table-header" }, [
                  _createElementVNode("th", { class: "select-column" }),
                  _createElementVNode("th", null, "顧客コード"),
                  _createElementVNode("th", null, "顧客名"),
                  _createElementVNode("th", null, "顧客名カナ")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.loading && _ctx.loading.isFirstLoadFinished && _ctx.customerTable.list.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("td", {
                        colspan: "10",
                        class: "no-data"
                      }, " データがありません ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerTable.list, (customer) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "stripe-tr",
                    key: customer.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "link-button edit-remove-link",
                        onClick: ($event: any) => (_ctx.select(customer))
                      }, "選択", 8, _hoisted_9)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(customer.id), 1),
                    _createElementVNode("td", null, _toDisplayString(customer.name), 1),
                    _createElementVNode("td", null, _toDisplayString(customer.kana), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createVNode(_component_pager, {
              itemIndex: _ctx.searchReq.startIndex,
              itemsInPage: _ctx.searchReq.length,
              itemLength: _ctx.customerTable.allCount,
              onClickPage: _ctx.changePage
            }, null, 8, ["itemIndex", "itemsInPage", "itemLength", "onClickPage"])
          ])
        ]),
        _: 1
      }, 8, ["onClickBackground"]))
    : _createCommentVNode("", true)
}